/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_OPEN_PRESENTATION = gql`
  query GetOpenRegReferredSections($openRegId: String) {
    getOpenRegReferredSections(openRegID: $openRegId) {
      myPresentations {
        name
        id
        status
        year
        referal {
          id
          partition
          inviteType
        }
        mySections {
          name
          description
          images
          isVisible
          myCostumeType {
            name
            price
            minDownPayment
            id
            images
            isVisible
            inventoryDetail {
              isDefaultSold
              isSpecialReserveSold
              isSectionSpecificSold
            }
          }
        }
      }
    }
  }
`;
